// src/components/Footer.jsx
import { FaLinkedin, FaWhatsapp, FaEnvelope } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-gray-400 pt-12 pb-6  border-t border-slate-800">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 px-6 text-center md:text-left">
        {/* Brand */}
        <div>
          <h2 className="text-2xl font-extrabold bg-gradient-to-r from-indigo-400 via-pink-400 to-purple-400 bg-clip-text text-transparent">
            Janardan Nepal
          </h2>
          <p className="text-sm mt-2">
            Managing Director, Entrepreneur, Travel Expert
          </p>
        </div>

        {/* Links */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-3">Explore</h3>
          <ul className="space-y-2">
            <li>
              <a href="/about" className="hover:text-indigo-400">
                About
              </a>
            </li>
            <li>
              <a href="/experience" className="hover:text-indigo-400">
                Experience
              </a>
            </li>
            <li>
              <a href="/projects" className="hover:text-indigo-400">
                Projects
              </a>
            </li>
            <li>
              <a href="/contact" className="hover:text-indigo-400">
                Contact
              </a>
            </li>
          </ul>
        </div>

        {/* Socials */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-3">Connect</h3>
          <div className="flex justify-center md:justify-start gap-6 text-2xl">
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noreferrer"
              className="hover:text-indigo-400"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://wa.me/9779841492029"
              target="_blank"
              rel="noreferrer"
              className="hover:text-green-400"
            >
              <FaWhatsapp />
            </a>
            <a
              href="mailto:info@topoftheworldadv.com"
              className="hover:text-red-400"
            >
              <FaEnvelope />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-slate-800 mt-8 pt-4 text-center text-sm text-gray-500">
        © {new Date().getFullYear()} Janardan Nepal. All rights reserved.
      </div>
    </footer>
  );
}
